(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3191],{

/***/ 91069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20406);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28526);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_csv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83606);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _pairy_pds_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61810);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(752);
/* harmony import */ var _state_user_atom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37271);
/* harmony import */ var _components_User_components_common_ProPlanUpgradeModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8898);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52903);












var CSVDownloadButton = function CSVDownloadButton(_ref) {
  var className = _ref.className,
      filename = _ref.filename,
      csvData = _ref.csvData,
      isLoading = _ref.isLoading,
      onClick = _ref.onClick,
      children = _ref.children;
  var toast = (0,_pairy_pds_react__WEBPACK_IMPORTED_MODULE_3__/* .useToast */ .pm)();
  var userInfo = (0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useAtomValue */ .Dv)(_state_user_atom__WEBPACK_IMPORTED_MODULE_4__/* .userInfoAtom */ .w);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isUpgradeModalOpen = _useState[0],
      setIsUpgradeModalOpen = _useState[1];

  var pendingDownload = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);
  var csvLinkRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (pendingDownload.current && !isLoading && csvData && csvData.length > 0) {
      var _csvLinkRef$current;

      pendingDownload.current = false;
      (_csvLinkRef$current = csvLinkRef.current) === null || _csvLinkRef$current === void 0 ? void 0 : _csvLinkRef$current.link.click();
    }
  }, [isLoading, csvData]);

  var handleClick = /*#__PURE__*/function () {
    var _ref2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
      var _userInfo$subscriptio, _csvLinkRef$current2;

      return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.stopPropagation();

              if (!((userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$subscriptio = userInfo.subscriptionPlan) === null || _userInfo$subscriptio === void 0 ? void 0 : _userInfo$subscriptio.name) === 'Free')) {
                _context.next = 5;
                break;
              }

              toast('해당 기능은 Basic 플랜부터 이용할 수 있습니다');
              setIsUpgradeModalOpen(true);
              return _context.abrupt("return");

            case 5:
              if (!isLoading) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              if (!onClick) {
                _context.next = 12;
                break;
              }

              pendingDownload.current = true;
              _context.next = 11;
              return onClick();

            case 11:
              return _context.abrupt("return");

            case 12:
              (_csvLinkRef$current2 = csvLinkRef.current) === null || _csvLinkRef$current2 === void 0 ? void 0 : _csvLinkRef$current2.link.click();

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(react_csv__WEBPACK_IMPORTED_MODULE_1__.CSVLink, {
      ref: csvLinkRef,
      filename: "".concat(filename, ".csv"),
      data: csvData !== null && csvData !== void 0 ? csvData : [],
      style: {
        display: 'none'
      }
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
      className: className,
      variant: "zinc_200",
      textVariant: "md-medium",
      radius: 9999,
      onClick: handleClick,
      disabled: isLoading,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_3__/* .Stack */ .Kq, {
        gap: 4,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
          icon: isLoading ? 'ph:spinner' : 'ph:download-simple',
          size: 17
        }), children !== null && children !== void 0 ? children : '열람 기록 다운로드 (CSV)']
      })
    }), isUpgradeModalOpen && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_User_components_common_ProPlanUpgradeModal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      onOpenChange: setIsUpgradeModalOpen
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CSVDownloadButton);

/***/ }),

/***/ 69292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61810);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52903);





var DeletionNotice = function DeletionNotice(_ref) {
  var clientName = _ref.clientName,
      linkName = _ref.linkName;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
      as: "p",
      variant: "lg-regular",
      children: ["\uC0AD\uC81C \uC2DC, ", (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("b", {
        children: clientName
      }), "\uC5D0\uAC8C \uBCF4\uB0B8 ", (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("b", {
        children: linkName
      }), " \uB9C1\uD06C\uAC00 \uB3D9\uC791\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.", (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("br", {}), "\uADF8\uB798\uB3C4 \uC0AD\uC81C\uD560\uAE4C\uC694?"]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
      as: "p",
      variant: "sm-semibold",
      color: "zinc_400",
      marginTop: 8,
      children: "\uACF5\uC720 \uB9C1\uD06C\uB294 \uC0AD\uC81C \uD6C4 \uBCF5\uAD6C\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4."
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (DeletionNotice);

/***/ }),

/***/ 17743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_LinkCopyButton; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__(50381);
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(62350);
// EXTERNAL MODULE: ./utils/api.ts + 1 modules
var api = __webpack_require__(74457);
;// CONCATENATED MODULE: ./hooks/mutations/client/useUpdateClientShare.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var updateClientShare = function updateClientShare(_ref) {
  var clientId = _ref.clientId,
      type = _ref.type,
      id = _ref.id;
  return api/* api.put */.h.put('/client/share', {
    clientId: clientId,
    type: type,
    id: id
  });
};

var useUpdateClientShare = function useUpdateClientShare(options) {
  return (0,useMutation/* useMutation */.D)(updateClientShare, _objectSpread({}, options));
};

/* harmony default export */ var client_useUpdateClientShare = (useUpdateClientShare);
// EXTERNAL MODULE: ./hooks/useShareUrl.ts
var useShareUrl = __webpack_require__(52650);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/common/LinkCopyButton/index.tsx









var LinkCopyButton = function LinkCopyButton(_ref) {
  var className = _ref.className,
      hashId = _ref.hashId,
      clientId = _ref.clientId,
      id = _ref.id,
      type = _ref.type,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? '고객에게 보낼 링크' : _ref$content,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'inlineBorderLess' : _ref$variant;

  var _useUpdateClientShare = client_useUpdateClientShare(),
      mutate = _useUpdateClientShare.mutate;

  var toast = (0,src/* useToast */.pm)();

  var _useShareUrl = (0,useShareUrl/* default */.Z)({
    targetType: type === 'file' ? 'CLIENT_FILE' : 'CLIENT_LINK',
    identifier: hashId
  }),
      url = _useShareUrl.url;

  var handleClickLinkCopyButton = function handleClickLinkCopyButton(e) {
    e.stopPropagation();
    mutate({
      type: type,
      id: id,
      clientId: clientId
    });
    copy_to_clipboard_default()(url);
    toast('링크가 복사되었습니다.');
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [variant === 'inlineBorderLess' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
      className: className,
      variant: "skyblue_100",
      textVariant: "sm-medium",
      radius: 4,
      paddingX: 8,
      paddingY: 4,
      borderLess: true,
      InnerWrappeGap: 4,
      leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
        icon: "ph:link",
        size: 17,
        color: "skyblue_400"
      }),
      onClick: handleClickLinkCopyButton,
      children: content
    }), variant === 'basic' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
      className: className,
      width: "100%",
      variant: "skyblue_400",
      textVariant: "md-medium",
      radius: 99,
      paddingY: 8,
      InnerWrappeGap: 4,
      leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
        icon: "ph:link",
        size: 17
      }),
      onClick: handleClickLinkCopyButton,
      children: content
    })]
  });
};

/* harmony default export */ var common_LinkCopyButton = (LinkCopyButton);

/***/ }),

/***/ 43891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pdf_VersionDropdown; }
});

// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs + 1 modules
var dist = __webpack_require__(46653);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 1 modules
var useQuery = __webpack_require__(7040);
// EXTERNAL MODULE: ./utils/api.ts + 1 modules
var api = __webpack_require__(74457);
;// CONCATENATED MODULE: ./hooks/queries/file/useFileVersionList.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var getFileVersionList = function getFileVersionList(_ref) {
  var fileId = _ref.fileId,
      clientId = _ref.clientId;
  return api/* api.get */.h.get('/file/version/list', {
    params: {
      fileId: fileId,
      clientId: clientId
    }
  });
};

var useFileVersionList = function useFileVersionList(request, options) {
  return (0,useQuery/* useQuery */.a)(['getFileVersionList', request], function () {
    return getFileVersionList(request);
  }, _objectSpread({}, options));
};

/* harmony default export */ var file_useFileVersionList = (useFileVersionList);
// EXTERNAL MODULE: ./utils/getUTCDate.ts + 1 modules
var getUTCDate = __webpack_require__(52497);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
;// CONCATENATED MODULE: ./components/User/_components/pdf/VersionDropdown/index.styles.ts



var TriggerButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1f8nc2m4"
} : 0)("border-bottom:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";border-radius:4px;transition:all 0.15s ease-in-out;&:hover{background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.zinc_200;
}, ";}" + ( true ? "" : 0));
var VersionDropdownContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* DropdownMenuContent */.AW,  true ? {
  target: "e1f8nc2m3"
} : 0)("position:relative;top:10px;left:70px;display:flex;flex-direction:column;padding:8px;border:1px solid ", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.zinc_200;
}, ";background-color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, ";border-radius:4px;box-shadow:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.elevation.md;
}, ";gap:4px;" + ( true ? "" : 0));
var DropDownItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* DropdownMenuItem */.Xi,  true ? {
  target: "e1f8nc2m2"
} : 0)("display:flex;width:335px;align-items:center;justify-content:space-between;padding:4px 8px;border-radius:4px;color:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.zinc_300;
}, ";outline:none;transition:all 0.15s ease-in-out;&:hover{background-color:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.zinc_100;
}, ";color:", function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.zinc_400;
}, ";}" + ( true ? "" : 0));
var SelectedDropDownItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* DropdownMenuItem */.Xi,  true ? {
  target: "e1f8nc2m1"
} : 0)("display:flex;width:335px;align-items:center;justify-content:space-between;padding:4px 8px;background-color:", function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.skyblue_50;
}, ";border-radius:4px;color:", function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.skyblue_400;
}, ";outline:none;transition:all 0.15s ease-in-out;&:hover{background-color:", function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.zinc_100;
}, ";color:", function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.zinc_400;
}, ";}" + ( true ? "" : 0));
var FileNameText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Text */.xv,  true ? {
  target: "e1f8nc2m0"
} : 0)("max-width:270px;color:", function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.zinc_400;
}, ";transition:all 0.15s ease-in-out;&:hover{color:", function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.zinc_500;
}, ";}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/pdf/VersionDropdown/index.tsx








var FILE_NAME_SIZE = 20;
var SELECTED_FILE_NAME_SIZE = 10;

var getSliceName = function getSliceName(fileName, size) {
  if (fileName.length > size) {
    return fileName.substring(0, size) + '...';
  }

  return fileName;
};

var VersionDropdown = function VersionDropdown(_ref) {
  var _selectedFile$name;

  var clientId = _ref.clientId,
      originalFileId = _ref.originalFileId,
      selectedFileVersionId = _ref.selectedFileVersionId,
      handleFileVersionChange = _ref.handleFileVersionChange;

  var _useFileVersionList = file_useFileVersionList({
    fileId: originalFileId,
    clientId: clientId
  }, {
    select: function select(data) {
      return data.data.data.file;
    },
    enabled: Boolean(originalFileId)
  }),
      file = _useFileVersionList.data;

  var selectedFile = (0,react.useMemo)(function () {
    return file === null || file === void 0 ? void 0 : file.find(function (item) {
      return item.id === selectedFileVersionId;
    });
  }, [file, originalFileId, selectedFileVersionId]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Root */.fC, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Trigger */.xz, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TriggerButton, {
        gap: 4,
        padding: 4,
        alignItems: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "lg-semibold",
          color: "zinc_500",
          children: getSliceName((_selectedFile$name = selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.name) !== null && _selectedFile$name !== void 0 ? _selectedFile$name : '', SELECTED_FILE_NAME_SIZE)
        }), selectedFileVersionId === originalFileId ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "sm-medium",
          color: "skyblue_400",
          children: "\uD604\uC7AC \uBC84\uC804"
        }) : (selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.editedAt) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
          variant: "sm-medium",
          color: "zinc_400",
          children: [(0,getUTCDate/* getUTCDate */.E)(selectedFile.editedAt, 'yearMonthDay'), " \uC774\uC804 \uBC84\uC804"]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:caret-down",
          size: 17
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Portal */.Uv, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VersionDropdownContent, {
        children: file === null || file === void 0 ? void 0 : file.map(function (_ref2) {
          var id = _ref2.id,
              name = _ref2.name,
              editedAt = _ref2.editedAt;

          if (id === selectedFileVersionId) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SelectedDropDownItem, {
              onClick: function onClick() {
                return handleFileVersionChange(id);
              },
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                variant: "md-medium",
                color: "zinc_500",
                children: getSliceName(name, FILE_NAME_SIZE)
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                variant: "sm-medium",
                color: "inherit",
                children: "\uC120\uD0DD\uB428"
              })]
            }, id);
          } else if (id === originalFileId) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DropDownItem, {
              onClick: function onClick() {
                return handleFileVersionChange(id);
              },
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                variant: "md-medium",
                color: "zinc_500",
                children: getSliceName(name, FILE_NAME_SIZE)
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                variant: "sm-medium",
                color: "inherit",
                children: "\uCD5C\uC2E0 \uBC84\uC804"
              })]
            }, id);
          } else {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DropDownItem, {
              onClick: function onClick() {
                return handleFileVersionChange(id);
              },
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FileNameText, {
                variant: "md-medium",
                as: "div",
                children: getSliceName(name, FILE_NAME_SIZE)
              }), editedAt && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
                variant: "sm-medium",
                color: "inherit",
                children: [(0,getUTCDate/* getUTCDate */.E)(editedAt, 'yearMonthDay'), " \uC774\uC804 \uBC84\uC804"]
              })]
            }, id);
          }
        })
      })
    })]
  });
};

/* harmony default export */ var pdf_VersionDropdown = (VersionDropdown);

/***/ }),

/***/ 13618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ve": function() { return /* binding */ isLockedItem; }
/* harmony export */ });
/* unused harmony export getClientTrackList */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7040);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74457);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var isLockedItem = function isLockedItem(item) {
  return 'isLocked' in item;
};
var getClientTrackList = function getClientTrackList(_ref) {
  var type = _ref.type,
      id = _ref.id,
      sort = _ref.sort;
  return _utils_api__WEBPACK_IMPORTED_MODULE_1__/* .api.get */ .h.get("/client/track/list", {
    params: {
      type: type,
      id: id,
      sort: sort
    }
  });
};

var useClientTrackList = function useClientTrackList(request, options) {
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)(['getClientTrackList', request], function () {
    return getClientTrackList(request);
  }, _objectSpread({}, options));
};

/* harmony default export */ __webpack_exports__["ZP"] = (useClientTrackList);

/***/ }),

/***/ 14032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useShortShareTokenBatch; },
  "S": function() { return /* binding */ shortShareTokenCacheKey; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(55830);
// EXTERNAL MODULE: ./hooks/queries/share/useShortShareToken.ts
var useShortShareToken = __webpack_require__(52299);
;// CONCATENATED MODULE: ./utils/concurrency.ts



/**
 * 동시 실행 개수를 제한하면서 순회한다.
 * 고객 수백 명의 단축 링크를 한 번에 발급할 때 요청이 폭증하지 않게 한다.
 */
var mapWithConcurrency = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(items, limit, task) {
    var results, cursor, worker;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            results = new Array(items.length);
            cursor = 0;

            worker = /*#__PURE__*/function () {
              var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                var index;
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!(cursor < items.length)) {
                          _context.next = 8;
                          break;
                        }

                        index = cursor;
                        cursor += 1;
                        _context.next = 5;
                        return task(items[index]);

                      case 5:
                        results[index] = _context.sent;
                        _context.next = 0;
                        break;

                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function worker() {
                return _ref2.apply(this, arguments);
              };
            }();

            _context2.next = 5;
            return Promise.all(Array.from({
              length: Math.min(limit, items.length)
            }, function () {
              return worker();
            }));

          case 5:
            return _context2.abrupt("return", results);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function mapWithConcurrency(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./hooks/useShortShareTokenBatch.ts



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






/** 한 번에 던지는 발급 요청 수. 고객 수백 명이어도 서버를 몰아치지 않게 제한한다. */

var ISSUE_CONCURRENCY = 8;
var shortShareTokenCacheKey = function shortShareTokenCacheKey(_ref) {
  var targetType = _ref.targetType,
      hash = _ref.hash;
  return "".concat(targetType, ":").concat(hash);
};
/**
 * 여러 공유 대상의 단축 토큰을 필요할 때 한꺼번에 발급받는다.
 *
 * CSV 내보내기처럼 행이 많은 화면은 렌더 시점에 발급하면 페이지를 열 때마다
 * 요청이 쏟아지므로, 내보내기 버튼을 눌렀을 때만 발급한다.
 * 실패한 대상은 토큰 없이 남겨 호출부가 기존 긴 URL로 폴백하게 한다.
 */

var useShortShareTokenBatch = function useShortShareTokenBatch() {
  var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
  /* 이름은 tokens지만 담기는 값은 `/s/` 뒤에 붙일 별칭이다(커스텀 주소가 있으면 그것). */

  var _useState = (0,react.useState)({}),
      tokens = _useState[0],
      setTokens = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isIssuing = _useState2[0],
      setIsIssuing = _useState2[1];

  var issueTokens = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(requests) {
      var pending, issued;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              pending = requests.filter(function (_ref3) {
                var hash = _ref3.hash;
                return Boolean(hash);
              });
              setIsIssuing(true);
              _context2.prev = 2;
              _context2.next = 5;
              return mapWithConcurrency(pending, ISSUE_CONCURRENCY, /*#__PURE__*/function () {
                var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(request) {
                  var response;
                  return regenerator_default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return queryClient.fetchQuery((0,useShortShareToken/* shortShareTokenQueryKey */.QB)(request), function () {
                            return (0,useShortShareToken/* issueShortShareToken */.Qs)(request);
                          }, {
                            staleTime: Infinity,
                            cacheTime: Infinity
                          });

                        case 3:
                          response = _context.sent;
                          return _context.abrupt("return", [shortShareTokenCacheKey(request), (0,useShortShareToken/* pickShareAlias */.zB)(response.data.data)]);

                        case 7:
                          _context.prev = 7;
                          _context.t0 = _context["catch"](0);
                          return _context.abrupt("return", null);

                        case 10:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 7]]);
                }));

                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 5:
              issued = _context2.sent;
              setTokens(function (prev) {
                return _objectSpread(_objectSpread({}, prev), Object.fromEntries(issued.filter(function (entry) {
                  return entry !== null;
                })));
              });

            case 7:
              _context2.prev = 7;
              setIsIssuing(false);
              return _context2.finish(7);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2,, 7, 10]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [queryClient]);
  return {
    tokens: tokens,
    issueTokens: issueTokens,
    isIssuing: isIssuing
  };
};

/* harmony default export */ var hooks_useShortShareTokenBatch = (useShortShareTokenBatch);

/***/ }),

/***/ 65355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ tracking_clients; }
});

// EXTERNAL MODULE: ./components/Layouts/User/index.tsx + 6 modules
var User = __webpack_require__(55571);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./hooks/queries/file/useFile.ts
var useFile = __webpack_require__(73037);
// EXTERNAL MODULE: ./components/User/_components/common/NotFoundErrorModal/index.tsx
var NotFoundErrorModal = __webpack_require__(39947);
// EXTERNAL MODULE: ./components/User/_components/common/NavHeader/index.ts
var NavHeader = __webpack_require__(79701);
// EXTERNAL MODULE: ./components/User/_components/common/ProPlanUpgradeModal/index.tsx + 22 modules
var ProPlanUpgradeModal = __webpack_require__(8898);
// EXTERNAL MODULE: ./components/User/Pdf/Navigation/index.tsx
var Navigation = __webpack_require__(79001);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../packages/react-hooks/index.ts + 10 modules
var react_hooks = __webpack_require__(90114);
// EXTERNAL MODULE: ../../node_modules/jotai/esm/react.mjs
var esm_react = __webpack_require__(752);
// EXTERNAL MODULE: ./hooks/queries/client/useClientTrackList.ts
var useClientTrackList = __webpack_require__(13618);
// EXTERNAL MODULE: ./components/User/_components/common/LockedClientRowPlaceholder/index.tsx + 1 modules
var LockedClientRowPlaceholder = __webpack_require__(50000);
// EXTERNAL MODULE: ./components/User/_components/common/SortTypeDropdown/index.tsx + 1 modules
var SortTypeDropdown = __webpack_require__(69135);
// EXTERNAL MODULE: ./components/User/_components/common/CSVDownloadButton/index.tsx
var CSVDownloadButton = __webpack_require__(91069);
// EXTERNAL MODULE: ./constants/localStorageKey.ts
var localStorageKey = __webpack_require__(92872);
// EXTERNAL MODULE: ./utils/getUTCDate.ts + 1 modules
var getUTCDate = __webpack_require__(52497);
// EXTERNAL MODULE: ./utils/shareLink.ts
var shareLink = __webpack_require__(79629);
// EXTERNAL MODULE: ./utils/formatPhone.ts
var formatPhone = __webpack_require__(98819);
// EXTERNAL MODULE: ./state/user/atom.ts
var atom = __webpack_require__(37271);
// EXTERNAL MODULE: ./components/User/_components/pdf/PaywalledBlur/index.tsx
var PaywalledBlur = __webpack_require__(94731);
// EXTERNAL MODULE: ./components/User/_components/common/BlurredCompactItem/index.tsx
var BlurredCompactItem = __webpack_require__(90129);
// EXTERNAL MODULE: ./hooks/useShortShareTokenBatch.ts + 1 modules
var useShortShareTokenBatch = __webpack_require__(14032);
// EXTERNAL MODULE: ./components/User/_components/common/LinkCopyButton/index.tsx + 1 modules
var LinkCopyButton = __webpack_require__(17743);
// EXTERNAL MODULE: ./components/User/_components/common/DeleteConfirmModal/index.tsx + 1 modules
var DeleteConfirmModal = __webpack_require__(41641);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(62350);
// EXTERNAL MODULE: ./utils/api.ts + 1 modules
var api = __webpack_require__(74457);
;// CONCATENATED MODULE: ./hooks/mutations/file/useEditFileClient.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var editFileClient = function editFileClient(_ref) {
  var fileId = _ref.fileId,
      clientIds = _ref.clientIds,
      newClients = _ref.newClients;
  return api/* api.put */.h.put('/file/client', {
    fileId: fileId,
    clientIds: clientIds,
    newClients: newClients
  });
};

var useEditFileClient = function useEditFileClient(options) {
  return (0,useMutation/* useMutation */.D)(editFileClient, _objectSpread({}, options));
};

/* harmony default export */ var file_useEditFileClient = (useEditFileClient);
// EXTERNAL MODULE: ./components/User/_components/common/DeletionNotice/index.tsx
var DeletionNotice = __webpack_require__(69292);
;// CONCATENATED MODULE: ./hooks/mutations/file/useDeleteFileClient.ts


function useDeleteFileClient_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useDeleteFileClient_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useDeleteFileClient_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useDeleteFileClient_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var deleteFileClient = function deleteFileClient(_ref) {
  var fileId = _ref.fileId,
      clientId = _ref.clientId;
  return api/* api.delete */.h["delete"]('/file/client', {
    params: {
      fileId: fileId,
      clientId: clientId
    }
  });
};

var useDeleteFileClient = function useDeleteFileClient(options) {
  return (0,useMutation/* useMutation */.D)(deleteFileClient, useDeleteFileClient_objectSpread({}, options));
};

/* harmony default export */ var file_useDeleteFileClient = (useDeleteFileClient);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
;// CONCATENATED MODULE: ./components/User/Pdf/TrackingClients/Primary/OneToOne/Box/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var BottomButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11er3tm0"
} : 0)( true ? {
  name: "neb7l7",
  styles: "display:flex;width:100%;margin-top:6px;gap:8px"
} : 0);
// EXTERNAL MODULE: ./components/User/_components/common/Star/index.tsx + 4 modules
var Star = __webpack_require__(96763);
;// CONCATENATED MODULE: ./components/User/Pdf/TrackingClients/Primary/OneToOne/Box/Client/index.styles.ts


var BoxWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Box */.xu,  true ? {
  target: "ewe7d501"
} : 0)("cursor:pointer;&:hover{box-shadow:", function (_ref) {
  var theme = _ref.theme;
  return theme.elevation.xs;
}, ";}transition:box-shadow 0.15s ease-in-out;" + ( true ? "" : 0));
var Line = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewe7d500"
} : 0)("width:1px;height:14px;background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.zinc_200;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/Pdf/TrackingClients/Primary/OneToOne/Box/Client/index.tsx









var Client = function Client(_ref) {
  var id = _ref.id,
      name = _ref.name,
      company = _ref.company,
      phone = _ref.phone,
      isChecked = _ref.isChecked,
      like = _ref.like,
      readCount = _ref.readCount,
      lastAction = _ref.lastAction,
      rightIcon = _ref.rightIcon,
      onClick = _ref.onClick,
      priorReadCount = _ref.priorReadCount;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BoxWrapper, {
    onClick: onClick,
    rightIcon: rightIcon,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 8,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Dot */.oT, {
          color: isChecked ? 'transparent' : 'vermillion_400',
          marginTop: 5,
          marginRight: 5,
          marginBottom: 5,
          marginLeft: 5
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        direction: "column",
        gap: 8,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          alignItems: "center",
          gap: 4,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            as: "p",
            variant: "md-bold",
            children: name || company || (phone ? (0,formatPhone/* formatKoreanPhoneNumber */.s$)(phone) : null) || '(이름 없음)'
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Star/* default */.Z, {
            like: like,
            clientId: id
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          gap: 8,
          alignItems: "center",
          width: "fit-content",
          children: [readCount && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
            gap: 8,
            width: "fit-content",
            alignItems: "center",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "sm-medium",
              children: "\uC5F4\uB78C \uD69F\uC218"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
              variant: "sm-semibold",
              children: [readCount, "\uD68C"]
            })]
          }), Number(priorReadCount) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kC, {
            width: "fit-content",
            alignItems: "center",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
              variant: "sm-medium",
              color: "zinc_400",
              children: ["(\uC774\uC804\uBC84\uC804 \uC5F4\uB78C ", priorReadCount, "\uD68C)"]
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Line, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
            width: "fit-content",
            alignItems: "center",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "sm-semibold",
              marginRight: 8,
              color: "zinc_400",
              children: "\uCD5C\uADFC \uC5F4\uB78C"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "sm-regular",
              color: "zinc_400",
              children: lastAction ? (0,getUTCDate/* getUTCDate */.E)(lastAction, 'withYear') : '없음'
            })]
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var Box_Client = (Client);
;// CONCATENATED MODULE: ./components/User/Pdf/TrackingClients/Primary/OneToOne/Box/index.tsx
















var Box = function Box(_ref) {
  var _fileData$name;

  var id = _ref.id,
      isChecked = _ref.isChecked,
      lastAction = _ref.lastAction,
      like = _ref.like,
      name = _ref.name,
      company = _ref.company,
      phone = _ref.phone,
      readCount = _ref.readCount,
      priorReadCount = _ref.priorReadCount,
      hashId = _ref.hashId;
  var router = (0,next_router.useRouter)();
  var fileId = Number(router.query.fileId);

  var _useFile = (0,useFile/* default */.Z)({
    fileId: fileId
  }, {
    enabled: Boolean(fileId),
    select: function select(data) {
      return data.data.data.file;
    }
  }),
      fileData = _useFile.data;

  var _useState = (0,react.useState)(false),
      isOpenModal = _useState[0],
      setIsOpenModal = _useState[1];

  var handleClickDeleteClientButton = (0,react.useCallback)(function (e) {
    e.stopPropagation();
    setIsOpenModal(true);
  }, []);
  var deleteClientFile = file_useEditFileClient();

  var _useDeleteFileClient = file_useDeleteFileClient(),
      mutate = _useDeleteFileClient.mutate;

  var deleteClient = react.useCallback(function () {
    mutate({
      fileId: fileId,
      clientId: id
    }, {
      onSuccess: function onSuccess() {
        return router.reload();
      }
    });
    return;
  }, [deleteClientFile, fileId, id, router]);
  var handleClickClient = (0,react.useCallback)(function () {
    router.push("/user/client/pdf-tracking?clientId=".concat(id, "&fileId=").concat(fileId));
  }, [fileId, id, router]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Client, {
      id: id,
      name: name,
      company: company,
      phone: phone,
      isChecked: isChecked,
      like: like,
      readCount: readCount,
      priorReadCount: priorReadCount,
      lastAction: lastAction,
      email: null,
      onClick: handleClickClient,
      rightIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomButtonWrapper, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
          variant: "zinc_300",
          textVariant: "sm-medium",
          radius: 4,
          borderLess: true,
          onClick: handleClickDeleteClientButton,
          leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
            icon: "ph:trash",
            size: 17
          }),
          children: "\uB9C1\uD06C \uC0AD\uC81C"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkCopyButton/* default */.Z, {
          hashId: hashId,
          clientId: id,
          id: fileId,
          type: "file"
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeleteConfirmModal/* default */.Z, {
      isOpen: isOpenModal,
      setIsOpen: setIsOpenModal,
      onClick: deleteClient,
      content: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeletionNotice/* default */.Z, {
        clientName: name || company || (phone ? (0,formatPhone/* formatKoreanPhoneNumber */.s$)(phone) : '') || '',
        linkName: (_fileData$name = fileData === null || fileData === void 0 ? void 0 : fileData.name) !== null && _fileData$name !== void 0 ? _fileData$name : ''
      })
    })]
  });
};

/* harmony default export */ var OneToOne_Box = (Box);
;// CONCATENATED MODULE: ./components/User/Pdf/TrackingClients/Primary/OneToOne/index.tsx



function OneToOne_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OneToOne_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OneToOne_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OneToOne_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
























var items = [{
  label: '최신 생성일 순',
  value: 'latestCreation'
}, {
  label: '자주 열람한 순',
  value: 'most'
}, {
  label: '최근 열람 시간 순',
  value: 'recent'
}, {
  label: '고객 대표명 순',
  value: 'name'
}];

var OneToOne = function OneToOne() {
  var router = (0,next_router.useRouter)();
  var userInfo = (0,esm_react/* useAtomValue */.Dv)(atom/* userInfoAtom */.w);

  var _useLocalStorage = (0,react_hooks/* useLocalStorage */._)(localStorageKey/* localStorageKey.fileOrLinkDropdown */._.fileOrLinkDropdown, 'latestCreation'),
      _useLocalStorage2 = (0,slicedToArray/* default */.Z)(_useLocalStorage, 2),
      sortType = _useLocalStorage2[0],
      setSortType = _useLocalStorage2[1];

  var fileId = Number(router.query.fileId);

  var _useFile = (0,useFile/* default */.Z)({
    fileId: fileId
  }, {
    enabled: Boolean(fileId),
    select: function select(data) {
      return data.data.data.file;
    }
  }),
      fileData = _useFile.data;

  var _useClientTrackList = (0,useClientTrackList/* default */.ZP)({
    type: 'file',
    id: fileId,
    sort: sortType !== null && sortType !== void 0 ? sortType : 'most'
  }, {
    enabled: Boolean(fileId) && fileData != null && !fileData.isBulk,
    select: function select(data) {
      return data.data.data.clients;
    },
    keepPreviousData: true
  }),
      clientTrackListData = _useClientTrackList.data;

  var _useShortShareTokenBa = (0,useShortShareTokenBatch/* default */.Z)(),
      tokens = _useShortShareTokenBa.tokens,
      issueTokens = _useShortShareTokenBa.issueTokens,
      isIssuing = _useShortShareTokenBa.isIssuing;

  var csvRows = react.useMemo(function () {
    var _clientTrackListData$;

    return (_clientTrackListData$ = clientTrackListData === null || clientTrackListData === void 0 ? void 0 : clientTrackListData.filter(function (item) {
      return !(0,useClientTrackList/* isLockedItem */.ve)(item);
    })) !== null && _clientTrackListData$ !== void 0 ? _clientTrackListData$ : [];
  }, [clientTrackListData]);
  var csvData = react.useMemo(function () {
    return csvRows.map(function (client, index) {
      var _client$email;

      return {
        '열람 ID': index + 1,
        '고객 이름': client.name || client.company || (client.phone ? (0,formatPhone/* formatKoreanPhoneNumber */.s$)(client.phone) : null) || '(이름 없음)',
        이메일: (_client$email = client.email) !== null && _client$email !== void 0 ? _client$email : '-',
        '열람 시간': client.lastAction ? (0,getUTCDate/* getUTCDate */.E)(client.lastAction, 'withYear') : '-',
        '열람 횟수': client.readCount,
        '공유 링크': function () {
          var token = tokens[(0,useShortShareTokenBatch/* shortShareTokenCacheKey */.S)({
            targetType: 'CLIENT_FILE',
            hash: client.hashId
          })];
          /* 발급에 실패한 행은 기존 URL로 폴백한다. 기존 URL도 계속 유효하다. */

          return token ? (0,shareLink/* getShortShareLink */.qB)({
            token: token,
            domain: userInfo === null || userInfo === void 0 ? void 0 : userInfo.domain
          }) : (0,shareLink/* getFileShareLink */.c0)({
            hashId: client.hashId,
            isBulk: false,
            domain: userInfo === null || userInfo === void 0 ? void 0 : userInfo.domain
          });
        }()
      };
    });
  }, [csvRows, tokens, userInfo === null || userInfo === void 0 ? void 0 : userInfo.domain]);

  var _useState = (0,react.useState)(false),
      isUpgradeModalOpen = _useState[0],
      setIsUpgradeModalOpen = _useState[1];

  var firstBlurredIndex = (clientTrackListData !== null && clientTrackListData !== void 0 ? clientTrackListData : []).findIndex(function (item) {
    return !(0,useClientTrackList/* isLockedItem */.ve)(item) && item.isBlurred;
  });

  if (!fileData || !clientTrackListData) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      direction: "column",
      gap: 16,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
          display: "inline-flex",
          alignItems: "center",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            as: "p",
            variant: "lg-semibold",
            marginRight: 16,
            children: "\uC774 \uD30C\uC77C\uC744 \uBC1B\uC740 \uACE0\uAC1D"
          }), clientTrackListData.length !== 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CSVDownloadButton/* default */.Z, {
            filename: "".concat(fileData.name, "_pdf\uD30C\uC77C_\uACE0\uAC1D\uBAA9\uB85D-").concat((0,getUTCDate/* getUTCDate */.E)('', 'yearMonthDay2')),
            csvData: csvData,
            isLoading: isIssuing,
            onClick: function onClick() {
              return issueTokens(csvRows.map(function (client) {
                return {
                  targetType: 'CLIENT_FILE',
                  hash: client.hashId
                };
              }));
            },
            children: "\uACE0\uAC1D \uB9C1\uD06C \uB2E4\uC6B4\uB85C\uB4DC (CSV)"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kC, {
          display: "inline-flex",
          alignItems: "center",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SortTypeDropdown/* default */.Z, {
            initialValue: sortType,
            items: items,
            onValueChanges: function onValueChanges(value) {
              return setSortType(value);
            }
          })
        })]
      }), clientTrackListData.length === 0 ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
        direction: "column",
        alignItems: "center",
        marginTop: 16,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:user-focus",
          size: 48,
          color: "zinc_400"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          as: "p",
          variant: "2xl-semibold",
          color: "zinc_400",
          marginTop: 16,
          textAlign: "center",
          children: "\uC67C\uCABD \uBC84\uD2BC\uC744 \uB20C\uB7EC \uBB38\uC11C \uACF5\uC720 \uB9C1\uD06C\uB97C \uC0DD\uC131\uD574\uBCF4\uC138\uC694."
        })]
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Stack */.Kq, {
        direction: "column",
        gap: 8,
        children: clientTrackListData === null || clientTrackListData === void 0 ? void 0 : clientTrackListData.map(function (clientTrackItem, index) {
          if ((0,useClientTrackList/* isLockedItem */.ve)(clientTrackItem)) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlurredCompactItem/* default */.Z, {
              onUpgradeClick: function onUpgradeClick() {
                return setIsUpgradeModalOpen(true);
              },
              showBorder: true,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LockedClientRowPlaceholder/* default */.Z, {})
            }, "locked-".concat(index));
          }

          return clientTrackItem.isBlurred ? index === firstBlurredIndex ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaywalledBlur/* default */.Z, {
            title: "\uCD5C\uADFC 7\uC77C \uB370\uC774\uD130\uB9CC \uD655\uC778\uD560 \uC218 \uC788\uC5B4\uC694",
            description: "\uC5C5\uADF8\uB808\uC774\uB4DC\uD558\uBA74 \uC804\uCCB4 \uAE30\uAC04 \uB370\uC774\uD130\uB97C \uD655\uC778\uD560 \uC218 \uC788\uC5B4\uC694.",
            onUpgradeClick: function onUpgradeClick() {
              return setIsUpgradeModalOpen(true);
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OneToOne_Box, OneToOne_objectSpread({}, clientTrackItem))
          }, clientTrackItem.id) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlurredCompactItem/* default */.Z, {
            onUpgradeClick: function onUpgradeClick() {
              return setIsUpgradeModalOpen(true);
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OneToOne_Box, OneToOne_objectSpread({}, clientTrackItem))
          }, clientTrackItem.id) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OneToOne_Box, OneToOne_objectSpread({}, clientTrackItem), clientTrackItem.id);
        })
      })]
    }), isUpgradeModalOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal/* default */.Z, {
      onOpenChange: setIsUpgradeModalOpen
    })]
  });
};

/* harmony default export */ var Primary_OneToOne = (OneToOne);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 1 modules
var useQuery = __webpack_require__(7040);
;// CONCATENATED MODULE: ./hooks/queries/file/useFileBulkClientTrackList.ts


function useFileBulkClientTrackList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useFileBulkClientTrackList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useFileBulkClientTrackList_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useFileBulkClientTrackList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getFileBulkClientTrackList = function getFileBulkClientTrackList(_ref) {
  var fileId = _ref.fileId,
      sort = _ref.sort;
  return api/* api.get */.h.get("/file/bulk/client/track/list", {
    params: {
      fileId: fileId,
      sort: sort
    }
  });
};

var useFileBulkClientTrackList = function useFileBulkClientTrackList(request, options) {
  return (0,useQuery/* useQuery */.a)(['getFileBulkClientTrackList', request], function () {
    return getFileBulkClientTrackList(request);
  }, useFileBulkClientTrackList_objectSpread({
    refetchOnWindowFocus: false
  }, options));
};

/* harmony default export */ var file_useFileBulkClientTrackList = (useFileBulkClientTrackList);
// EXTERNAL MODULE: ./components/User/_components/pdf/VersionDropdown/index.tsx + 2 modules
var VersionDropdown = __webpack_require__(43891);
;// CONCATENATED MODULE: ./components/User/Pdf/TrackingClients/Primary/Bulk/Box/index.styles.ts

var Divider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "epwo5ce0"
} : 0)("padding-right:16px;border-right:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";margin-right:16px;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/User/Pdf/TrackingClients/Primary/Bulk/Box/index.tsx








var Box_Box = function Box(_ref) {
  var name = _ref.name,
      readCount = _ref.readCount,
      lastAction = _ref.lastAction,
      isChecked = _ref.isChecked;
  var router = (0,next_router.useRouter)();

  var handleClickBox = function handleClickBox() {
    router.push("/user/pdf/activity-analysis?fileId=".concat(router.query.fileId));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Box */.xu, {
    as: "button",
    onClick: handleClickBox,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 8,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Dot */.oT, {
          color: isChecked ? 'transparent' : 'vermillion_400',
          marginTop: 5,
          marginRight: 5,
          marginBottom: 5,
          marginLeft: 5
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        direction: "column",
        gap: 8,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Stack */.Kq, {
          alignItems: "center",
          gap: 4,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            as: "p",
            variant: "md-bold",
            children: name !== null && name !== void 0 ? name : '익명'
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider, {
            children: readCount && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                variant: "sm-semibold",
                marginRight: 8,
                children: "\uC5F4\uB78C \uD69F\uC218"
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
                variant: "sm-semibold",
                children: [readCount, "\uD68C"]
              })]
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "sm-semibold",
              marginRight: 8,
              color: "zinc_400",
              children: "\uCD5C\uADFC \uC5F4\uB78C"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "sm-regular",
              color: "zinc_400",
              children: lastAction ? (0,getUTCDate/* getUTCDate */.E)(lastAction, 'withYear') : '없음'
            })]
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var Bulk_Box = (Box_Box);
;// CONCATENATED MODULE: ./components/User/Pdf/TrackingClients/Primary/Bulk/index.tsx



function Bulk_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Bulk_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Bulk_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Bulk_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var Bulk_items = [{
  label: '최근 열람 시간 순',
  value: 'recent'
}, {
  label: '자주 열람한 순',
  value: 'most'
}];

var Bulk = function Bulk() {
  var _data$length;

  var router = (0,next_router.useRouter)();
  var fileId = Number(router.query.fileId);

  var _useState = (0,react.useState)(false),
      isUpgradeModalOpen = _useState[0],
      setIsUpgradeModalOpen = _useState[1];

  var _useLocalStorage = (0,react_hooks/* useLocalStorage */._)(localStorageKey/* localStorageKey.fileBulkDropdown */._.fileBulkDropdown, 'recent'),
      _useLocalStorage2 = (0,slicedToArray/* default */.Z)(_useLocalStorage, 2),
      sortType = _useLocalStorage2[0],
      setSortType = _useLocalStorage2[1];

  var _useState2 = (0,react.useState)(fileId),
      selectedFileVersionId = _useState2[0],
      setSelectedFileVersionId = _useState2[1];

  (0,react.useEffect)(function () {
    setSelectedFileVersionId(fileId);
  }, [fileId]);

  var _useFileBulkClientTra = file_useFileBulkClientTrackList({
    fileId: selectedFileVersionId,
    sort: sortType !== null && sortType !== void 0 ? sortType : 'recent'
  }, {
    enabled: Boolean(selectedFileVersionId),
    select: function select(data) {
      return data.data.data.clients;
    }
  }),
      data = _useFileBulkClientTra.data;

  var handleFileVersionChange = function handleFileVersionChange(id) {
    setSelectedFileVersionId(id);
  };

  var firstBlurredIndex = (data !== null && data !== void 0 ? data : []).findIndex(function (client) {
    return client.isBlurred;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    direction: "column",
    gap: 16,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "space-between",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 4,
        alignItems: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          gap: 4,
          width: "fit-content",
          alignItems: "center",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VersionDropdown/* default */.Z, {
            originalFileId: fileId,
            selectedFileVersionId: selectedFileVersionId,
            handleFileVersionChange: handleFileVersionChange
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            as: "p",
            variant: "xl-semibold",
            children: "\uC5F4\uC5B4\uBCF8 \uACE0\uAC1D"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "md-medium",
          color: "zinc_400",
          children: "\uCD1D ".concat((_data$length = data === null || data === void 0 ? void 0 : data.length) !== null && _data$length !== void 0 ? _data$length : '', "\uACF3")
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SortTypeDropdown/* default */.Z, {
        initialValue: sortType,
        items: Bulk_items,
        onValueChanges: function onValueChanges(value) {
          return setSortType(value);
        }
      })]
    }), (data === null || data === void 0 ? void 0 : data.length) === 0 ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kC, {
      direction: "column",
      alignItems: "center",
      marginTop: 32,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
        variant: "md-medium",
        color: "zinc_400",
        textAlign: "center",
        marginTop: 8,
        children: ["\uC88C\uCE21\uC5D0\uC11C \uD50C\uB7AB\uD3FC\uC744 \uC120\uD0DD\uD574", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uBC18\uC751 \uCD94\uC801\uC6A9 \uB9C1\uD06C\uB97C \uBCF5\uC0AC\uD55C \uB4A4", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uACE0\uAC1D\uC5D0\uAC8C \uBCF4\uB0B4\uB294 \uBA54\uC2DC\uC9C0\uC5D0 \uC0BD\uC785\uD558\uC138\uC694."]
      })
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Stack */.Kq, {
      direction: "column",
      gap: 8,
      className: 'pdf-tracking-client-list',
      children: data === null || data === void 0 ? void 0 : data.map(function (client, index) {
        var _client$email, _client$email2;

        return client.isBlurred ? index === firstBlurredIndex ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaywalledBlur/* default */.Z, {
          title: "\uCD5C\uADFC 7\uC77C \uB370\uC774\uD130\uB9CC \uD655\uC778\uD560 \uC218 \uC788\uC5B4\uC694",
          description: "\uC5C5\uADF8\uB808\uC774\uB4DC\uD558\uBA74 \uC804\uCCB4 \uAE30\uAC04 \uB370\uC774\uD130\uB97C \uD655\uC778\uD560 \uC218 \uC788\uC5B4\uC694.",
          onUpgradeClick: function onUpgradeClick() {
            return setIsUpgradeModalOpen(true);
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bulk_Box, Bulk_objectSpread({}, client))
        }, (_client$email = client.email) !== null && _client$email !== void 0 ? _client$email : index) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlurredCompactItem/* default */.Z, {
          onUpgradeClick: function onUpgradeClick() {
            return setIsUpgradeModalOpen(true);
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bulk_Box, Bulk_objectSpread({}, client))
        }, (_client$email2 = client.email) !== null && _client$email2 !== void 0 ? _client$email2 : index) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bulk_Box, Bulk_objectSpread({}, client), client.email);
      })
    }), isUpgradeModalOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal/* default */.Z, {
      onOpenChange: setIsUpgradeModalOpen
    })]
  });
};

/* harmony default export */ var Primary_Bulk = (Bulk);
;// CONCATENATED MODULE: ./components/User/Pdf/TrackingClients/Primary/index.tsx












var TrackingClients = function TrackingClients() {
  var router = (0,next_router.useRouter)();
  var fileId = Number(router.query.fileId);

  var _useState = (0,react.useState)(false),
      isNotFoundModalOpen = _useState[0],
      setIsNotFoundModalOpen = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isUpgradeModalOpen = _useState2[0],
      setIsUpgradeModalOpen = _useState2[1];

  var _useFile = (0,useFile/* default */.Z)({
    fileId: fileId
  }, {
    enabled: Boolean(fileId),
    select: function select(data) {
      return data.data.data.file;
    },
    onError: function onError(error) {
      var _error$response, _error$response2;

      if ((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 404) {
        setIsNotFoundModalOpen(true);
      } else if ((error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status) === 403) {
        setIsUpgradeModalOpen(true);
      }
    },
    retry: 1
  }),
      fileData = _useFile.data;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavHeader/* default */.Z, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {})
    }), fileData !== null && fileData !== void 0 && fileData.isBulk ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Primary_Bulk, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Primary_OneToOne, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotFoundErrorModal/* default */.Z, {
      isModalOpen: isNotFoundModalOpen,
      setModalOpen: setIsNotFoundModalOpen
    }), isUpgradeModalOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal/* default */.Z, {
      onOpenChange: setIsUpgradeModalOpen
    })]
  });
};

/* harmony default export */ var Primary = (TrackingClients);
// EXTERNAL MODULE: ./components/User/_components/pdf/PdfInfoWithButtons/index.tsx
var PdfInfoWithButtons = __webpack_require__(19743);
// EXTERNAL MODULE: ./components/User/_components/pdf/BulkLinkCopySection/index.tsx + 17 modules
var BulkLinkCopySection = __webpack_require__(43429);
// EXTERNAL MODULE: ./components/User/_components/pdf/BulkPdfInfoWithButtons/index.tsx + 13 modules
var BulkPdfInfoWithButtons = __webpack_require__(7446);
// EXTERNAL MODULE: ./components/User/_components/ui/BoxAccordion/index.tsx + 1 modules
var BoxAccordion = __webpack_require__(54148);
// EXTERNAL MODULE: ./styles/pulseAnimationCss.ts
var pulseAnimationCss = __webpack_require__(89089);
;// CONCATENATED MODULE: ./components/User/Pdf/TrackingClients/Secondary/OneToOne/index.styles.ts

var index_styles_Box = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e9qj3zi0"
} : 0)("padding:16px;border-width:0 0 1px;border-style:solid;border-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, ";&.last{border-width:0;border-radius:0 0 8px 8px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(52746);
// EXTERNAL MODULE: ../../node_modules/axios/index.js
var axios = __webpack_require__(89644);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./components/User/_components/common/AddClientList/index.tsx + 16 modules
var AddClientList = __webpack_require__(5354);
// EXTERNAL MODULE: ./components/User/_components/common/Loading/index.tsx + 2 modules
var Loading = __webpack_require__(30541);
;// CONCATENATED MODULE: ./hooks/queries/client/useClientFileList.ts


function useClientFileList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useClientFileList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useClientFileList_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useClientFileList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getClientFileList = function getClientFileList(_ref) {
  var fileId = _ref.fileId;
  return api/* api.get */.h.get("/client/file/list", {
    params: {
      fileId: fileId !== null && fileId !== void 0 ? fileId : undefined
    }
  });
};

var useClientFileList = function useClientFileList(request, options) {
  return (0,useQuery/* useQuery */.a)(['getClientFileList', request], function () {
    return getClientFileList(request);
  }, useClientFileList_objectSpread({}, options));
};

/* harmony default export */ var client_useClientFileList = (useClientFileList);
// EXTERNAL MODULE: ./hooks/queries/client/useClientList.ts
var useClientList = __webpack_require__(9416);
;// CONCATENATED MODULE: ./components/User/Pdf/TrackingClients/Secondary/OneToOne/EditClientsModal/index.tsx



function EditClientsModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function EditClientsModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EditClientsModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EditClientsModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var EditClientsModal = function EditClientsModal(_ref) {
  var _allClientsData$lengt, _addedClients$filter$, _allClientsData$lengt3, _fileData$name;

  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      onLimitExceeded = _ref.onLimitExceeded;
  var router = (0,next_router.useRouter)();
  var fileId = Number(router.query.fileId);

  var _useState = (0,react.useState)([]),
      selectedIds = _useState[0],
      setSelectedIds = _useState[1];

  var _useState2 = (0,react.useState)(null),
      addedClients = _useState2[0],
      setAddedClients = _useState2[1];

  var userInfo = (0,esm_react/* useAtomValue */.Dv)(atom/* userInfoAtom */.w);
  var toast = (0,src/* useToast */.pm)();

  var _useClientList = (0,useClientList/* default */.ZP)({
    sort: 'most'
  }, {
    select: function select(data) {
      return data.data.data.clients;
    }
  }),
      allClientsData = _useClientList.data;

  var clientLimitLabel = (0,react.useMemo)(function () {
    var _userInfo$subscriptio;

    var planName = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$subscriptio = userInfo.subscriptionPlan) === null || _userInfo$subscriptio === void 0 ? void 0 : _userInfo$subscriptio.name;

    if (planName === 'Basic') {
      return '100';
    }

    if (planName === 'Pro' || planName === 'Pro (test)') {
      return '1,000';
    }

    if (planName === 'Pro Plus') {
      return '10,000';
    }

    return '10';
  }, [userInfo]);
  var planLimit = (0,react.useMemo)(function () {
    var _LIMIT, _userInfo$subscriptio2, _userInfo$subscriptio3;

    var LIMIT = {
      Free: 10,
      Basic: 100,
      Pro: 1000,
      'Pro (test)': 1000,
      'Pro Plus': 10000
    };
    return (_LIMIT = LIMIT[(_userInfo$subscriptio2 = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$subscriptio3 = userInfo.subscriptionPlan) === null || _userInfo$subscriptio3 === void 0 ? void 0 : _userInfo$subscriptio3.name) !== null && _userInfo$subscriptio2 !== void 0 ? _userInfo$subscriptio2 : 'Free']) !== null && _LIMIT !== void 0 ? _LIMIT : 10;
  }, [userInfo]);
  var isAtLimit = ((_allClientsData$lengt = allClientsData === null || allClientsData === void 0 ? void 0 : allClientsData.length) !== null && _allClientsData$lengt !== void 0 ? _allClientsData$lengt : 0) + ((_addedClients$filter$ = addedClients === null || addedClients === void 0 ? void 0 : addedClients.filter(function (c) {
    return typeof c.id === 'string';
  }).length) !== null && _addedClients$filter$ !== void 0 ? _addedClients$filter$ : 0) >= planLimit;
  var handleLimitExceeded = (0,react.useCallback)(function () {
    var _userInfo$subscriptio4;

    var planName = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$subscriptio4 = userInfo.subscriptionPlan) === null || _userInfo$subscriptio4 === void 0 ? void 0 : _userInfo$subscriptio4.name;
    var MESSAGES = {
      Free: 'Free Plan에서는 고객을 10명까지 등록 가능합니다.',
      Basic: 'Basic Plan에서는 고객을 100명까지 등록 가능합니다.',
      Pro: 'Pro Plan에서는 고객을 1,000명까지 등록 가능합니다.',
      'Pro (test)': 'Pro Plan에서는 고객을 1,000명까지 등록 가능합니다.'
    };

    if (planName === 'Pro Plus') {
      toast('고객의 등록 최대 개수를 초과했습니다.');
    } else {
      var _MESSAGES;

      toast((_MESSAGES = MESSAGES[planName !== null && planName !== void 0 ? planName : 'Free']) !== null && _MESSAGES !== void 0 ? _MESSAGES : '고객의 등록 최대 개수를 초과했습니다.');
      setIsOpen(false);
      onLimitExceeded === null || onLimitExceeded === void 0 ? void 0 : onLimitExceeded();
    }
  }, [userInfo, toast, setIsOpen, onLimitExceeded]);

  var _useFile = (0,useFile/* default */.Z)({
    fileId: fileId
  }, {
    enabled: Boolean(fileId),
    select: function select(data) {
      return data.data.data.file;
    }
  }),
      fileData = _useFile.data;

  var _useClientFileList = client_useClientFileList({
    fileId: fileId
  }, {
    enabled: Boolean(fileId),
    retry: false,
    refetchOnWindowFocus: false,
    select: function select(data) {
      return data.data.data.clients;
    }
  }),
      data = _useClientFileList.data;

  var handleClickAddClient = (0,react.useCallback)(function (client) {
    setAddedClients(function (prev) {
      return prev ? [].concat((0,toConsumableArray/* default */.Z)(prev), [client]) : [client];
    });
    setSelectedIds(function (prev) {
      return [].concat((0,toConsumableArray/* default */.Z)(prev), [client.id]);
    });
  }, [data]);
  var handleClickRemoveClient = (0,react.useCallback)(function (id) {
    setSelectedIds(function (prev) {
      return prev.filter(function (prevId) {
        return prevId !== id;
      });
    });
    setAddedClients(function (prev) {
      return prev === null || prev === void 0 ? void 0 : prev.filter(function (client) {
        return client.id !== id;
      });
    });
  }, [addedClients]);
  var handleClickAddAllClients = (0,react.useCallback)(function () {
    if (data) {
      var filteredClients = data.filter(function (client) {
        return !selectedIds.includes(client.id) && !client.isSelected;
      });
      setAddedClients(function (prev) {
        var _prev$filter$map;

        return [].concat((0,toConsumableArray/* default */.Z)(filteredClients), (0,toConsumableArray/* default */.Z)((_prev$filter$map = prev === null || prev === void 0 ? void 0 : prev.filter(function (_ref2) {
          var isSelected = _ref2.isSelected;
          return !isSelected;
        }).map(function (client) {
          return EditClientsModal_objectSpread(EditClientsModal_objectSpread({}, client), {}, {
            isAddedForm: false,
            selected: false
          });
        })) !== null && _prev$filter$map !== void 0 ? _prev$filter$map : []));
      });
      setSelectedIds(data.map(function (client) {
        return client.id;
      }));
    }
  }, [addedClients, data]);
  var addClient = (0,react.useCallback)(function (client) {
    setAddedClients(function (prev) {
      return prev ? [].concat((0,toConsumableArray/* default */.Z)(prev), [client]) : [client];
    });
  }, [addedClients, data]);

  var _useEditFileClient = file_useEditFileClient({
    onSuccess: function onSuccess() {
      router.reload();
    },
    onError: function onError(error) {
      var _error$response;

      setLoading(false);

      if (axios_default().isAxiosError(error) && ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 403) {
        toast('고객의 등록 최대 개수를 초과했습니다.');
      }
    }
  }),
      mutate = _useEditFileClient.mutate;

  var handleClickCompleteButton = function handleClickCompleteButton() {
    var clientIds = addedClients === null || addedClients === void 0 ? void 0 : addedClients.filter(function (client) {
      return typeof client.id === 'number';
    }).map(function (client) {
      return client.id;
    });
    var newClients = addedClients === null || addedClients === void 0 ? void 0 : addedClients.filter(function (client) {
      return typeof client.id === 'string';
    }).map(function (_ref3) {
      var name = _ref3.name,
          email = _ref3.email,
          company = _ref3.company,
          phone = _ref3.phone,
          position = _ref3.position,
          department = _ref3.department,
          memo = _ref3.memo;
      return {
        name: name || undefined,
        email: email || undefined,
        company: company || undefined,
        phone: phone || undefined,
        position: position || undefined,
        department: department || undefined,
        memo: memo || undefined
      };
    });

    if (newClients !== null && newClients !== void 0 && newClients.length) {
      var _allClientsData$lengt2;

      var currentCount = (_allClientsData$lengt2 = allClientsData === null || allClientsData === void 0 ? void 0 : allClientsData.length) !== null && _allClientsData$lengt2 !== void 0 ? _allClientsData$lengt2 : 0;

      if (currentCount + newClients.length > planLimit) {
        handleLimitExceeded();
        return;
      }
    }

    setLoading(true);
    mutate({
      fileId: fileId,
      clientIds: clientIds !== null && clientIds !== void 0 && clientIds.length ? clientIds : [],
      newClients: newClients !== null && newClients !== void 0 && newClients.length ? newClients : []
    });
  };

  var _useState3 = (0,react.useState)(false),
      loading = _useState3[0],
      setLoading = _useState3[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Modal.Root */.u_.Root, {
    open: isOpen,
    onOpenChange: setIsOpen,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Modal.Content */.u_.Content, {
      width: "wide",
      loading: loading ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loading/* default */.Z, {}) : undefined,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Modal.Header */.u_.Header, {
        title: "\uC790\uB8CC\uBC1B\uC744 \uACE0\uAC1D \uB354\uD558\uAE30"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Modal.Body */.u_.Body, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AddClientList/* Root */.fC, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AddClientList/* Body */.uT, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddClientList/* ClientTabs */.Y2, {
              newClient: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddClientList/* NewClient */._r, {
                addClient: addClient,
                clients: [].concat((0,toConsumableArray/* default */.Z)(data !== null && data !== void 0 ? data : []), (0,toConsumableArray/* default */.Z)(addedClients !== null && addedClients !== void 0 ? addedClients : [])),
                clientCount: (_allClientsData$lengt3 = allClientsData === null || allClientsData === void 0 ? void 0 : allClientsData.length) !== null && _allClientsData$lengt3 !== void 0 ? _allClientsData$lengt3 : 0,
                planLimitLabel: clientLimitLabel,
                isAtLimit: isAtLimit,
                onLimitExceeded: handleLimitExceeded
              }),
              existingClient: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AddClientList/* ExistingClient */.Qk, {
                addAllClients: handleClickAddAllClients,
                children: [data === null || data === void 0 ? void 0 : data.filter(function (_ref4) {
                  var id = _ref4.id,
                      isSelected = _ref4.isSelected;
                  return !selectedIds.includes(id) && !isSelected;
                }).map(function (client) {
                  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddClientList/* ClientBox */["if"], {
                    email: client.email,
                    name: client.name,
                    company: client.company,
                    phone: client.phone,
                    onClick: function onClick() {
                      return handleClickAddClient(client);
                    }
                  }, client.id);
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                  variant: "md-semibold",
                  marginTop: 8,
                  marginBottom: 8,
                  children: "\uC774\uBBF8 \uB9C1\uD06C \uB9CC\uB4E0 \uACE0\uAC1D"
                }), data === null || data === void 0 ? void 0 : data.filter(function (_ref5) {
                  var isSelected = _ref5.isSelected;
                  return isSelected;
                }).map(function (_ref6) {
                  var id = _ref6.id,
                      name = _ref6.name,
                      email = _ref6.email,
                      company = _ref6.company,
                      phone = _ref6.phone;
                  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddClientList/* ClientBox */["if"], {
                    email: email,
                    name: name,
                    company: company,
                    phone: phone,
                    disabled: true
                  }, id);
                })]
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddClientList/* AddedClientList */.HN, {
              name: (_fileData$name = fileData === null || fileData === void 0 ? void 0 : fileData.name) !== null && _fileData$name !== void 0 ? _fileData$name : '',
              children: (0,toConsumableArray/* default */.Z)(addedClients !== null && addedClients !== void 0 ? addedClients : []).reverse().map(function (_ref7) {
                var email = _ref7.email,
                    id = _ref7.id,
                    name = _ref7.name,
                    company = _ref7.company,
                    phone = _ref7.phone;
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddClientList/* SelectedClientBox */.R8, {
                  email: email,
                  name: name,
                  company: company,
                  phone: phone,
                  onClick: function onClick() {
                    return handleClickRemoveClient(id);
                  }
                }, id);
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddClientList/* Footer */.$_, {
            onClick: handleClickCompleteButton,
            disabled: !addedClients || (addedClients === null || addedClients === void 0 ? void 0 : addedClients.length) === 0,
            children: "\uACE0\uAC1D\uC5D0\uAC8C \uBCF4\uB0BC \uB9C1\uD06C \uB9CC\uB4E4\uAE30"
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var OneToOne_EditClientsModal = (EditClientsModal);
;// CONCATENATED MODULE: ./components/User/Pdf/TrackingClients/Secondary/OneToOne/index.tsx



















var OneToOne_OneToOne = function OneToOne() {
  var router = (0,next_router.useRouter)();
  var fileId = Number(router.query.fileId);
  var userInfo = (0,esm_react/* useAtomValue */.Dv)(atom/* userInfoAtom */.w);
  var toast = (0,src/* useToast */.pm)();
  var sortType = (0,react_hooks/* useLocalStorageValue */.ZN)(localStorageKey/* localStorageKey.fileOrLinkDropdown */._.fileOrLinkDropdown);

  var _useClientTrackList = (0,useClientTrackList/* default */.ZP)({
    type: 'file',
    id: fileId,
    sort: sortType !== null && sortType !== void 0 ? sortType : 'most'
  }, {
    enabled: Boolean(fileId) && sortType != null,
    select: function select(data) {
      return data.data.data.clients;
    },
    keepPreviousData: true
  }),
      clientTrackListData = _useClientTrackList.data;

  var notSentClients = react.useMemo(function () {
    return clientTrackListData === null || clientTrackListData === void 0 ? void 0 : clientTrackListData.filter(function (client) {
      return !(0,useClientTrackList/* isLockedItem */.ve)(client) && !client.isShared;
    });
  }, [clientTrackListData]);

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  var _useState = (0,react.useState)(false),
      isProUpgradeModalOpen = _useState[0],
      setIsProUpgradeModalOpen = _useState[1];

  var handleAddNewClient = function handleAddNewClient() {
    if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.subscriptionPlan.name) == 'Free' && userInfo.fileCount >= 4) {
      setIsProUpgradeModalOpen(true);
      toast('Free Plan에서는 파일 3개까지 이용 가능합니다.');
      return;
    } else if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.subscriptionPlan.name) === 'Basic' && userInfo.fileCount >= 11) {
      setIsProUpgradeModalOpen(true);
      toast('Basic Plan에서는 파일 10개까지 이용 가능합니다.');
      return;
    }

    setIsOpen(true);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
      variant: "black_fill",
      textVariant: "lg-medium",
      radius: 9999,
      paddingY: 16,
      leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
        icon: "ph:plus",
        size: 19
      }),
      onClick: handleAddNewClient,
      css: clientTrackListData !== null && clientTrackListData !== void 0 && clientTrackListData.length ? undefined : pulseAnimationCss/* pulse */.d,
      children: "\uACE0\uAC1D\uC5D0\uAC8C \uBCF4\uB0BC \uBB38\uC11C \uACF5\uC720 \uB9C1\uD06C \uC0DD\uC131\uD558\uAE30"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BoxAccordion/* default */.Z, {
      title: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "lg-semibold",
          children: "\uC544\uC9C1 \uB9C1\uD06C\uB97C \uBCF4\uB0B4\uC9C0 \uC54A\uC740 \uACE0\uAC1D"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
          variant: "md-medium",
          color: "zinc_400",
          marginLeft: 8,
          children: [notSentClients === null || notSentClients === void 0 ? void 0 : notSentClients.length, "\uACF3"]
        })]
      }),
      children: notSentClients && notSentClients.length > 0 && notSentClients.map(function (_ref, index) {
        var id = _ref.id,
            name = _ref.name,
            hashId = _ref.hashId;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_Box, {
          className: index + 1 === notSentClients.length ? 'last' : '',
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
            justifyContent: "space-between",
            alignItems: "center",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* FlexItem */.B5, {
              flexGrow: 1,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                variant: "md-bold",
                children: name
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* FlexItem */.B5, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkCopyButton/* default */.Z, {
                hashId: hashId,
                clientId: id,
                id: fileId,
                type: "file"
              })
            })]
          })
        }, id);
      })
    }), isOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OneToOne_EditClientsModal, {
      isOpen: isOpen,
      setIsOpen: setIsOpen,
      onLimitExceeded: function onLimitExceeded() {
        return setIsProUpgradeModalOpen(true);
      }
    }), isProUpgradeModalOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal/* default */.Z, {
      onOpenChange: function onOpenChange(open) {
        setIsProUpgradeModalOpen(open);
      }
    })]
  });
};

/* harmony default export */ var Secondary_OneToOne = (OneToOne_OneToOne);
;// CONCATENATED MODULE: ./components/User/Pdf/TrackingClients/Secondary/index.tsx











var Secondary_TrackingClients = function TrackingClients() {
  var router = (0,next_router.useRouter)();
  var fileId = Number(router.query.fileId);

  var _useFile = (0,useFile/* default */.Z)({
    fileId: fileId
  }, {
    enabled: Boolean(fileId),
    select: function select(data) {
      return data.data.data.file;
    }
  }),
      fileData = _useFile.data;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      direction: "column",
      gap: 8,
      children: [fileData !== null && fileData !== void 0 && fileData.isBulk ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulkPdfInfoWithButtons/* default */.Z, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PdfInfoWithButtons/* default */.Z, {}), fileData !== null && fileData !== void 0 && fileData.isBulk ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulkLinkCopySection/* default */.Z, {
        fileName: fileData.name,
        fileThumbnail: fileData.thumnail
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Secondary_OneToOne, {})]
    })
  });
};

/* harmony default export */ var Secondary = (Secondary_TrackingClients);
;// CONCATENATED MODULE: ./components/User/Pdf/TrackingClients/index.tsx






var TrackingClients_TrackingClients = function TrackingClients() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(User/* default */.Z, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Secondary, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Primary, {})]
  });
};

/* harmony default export */ var Pdf_TrackingClients = (TrackingClients_TrackingClients);
;// CONCATENATED MODULE: ./pages/user/pdf/tracking-clients/index.tsx



var UserClientPdfTrackingClientsPage = function UserClientPdfTrackingClientsPage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pdf_TrackingClients, {});
};

/* harmony default export */ var tracking_clients = (UserClientPdfTrackingClientsPage);

/***/ }),

/***/ 98862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LG": function() { return /* binding */ TriggerChevronIcon; },
/* harmony export */   "c2": function() { return /* binding */ AccordionRoot; },
/* harmony export */   "o4": function() { return /* binding */ AccordionTrigger; },
/* harmony export */   "vF": function() { return /* binding */ AccordionContent; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36557);
/* harmony import */ var _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75694);
/* harmony import */ var _pairy_pds_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61810);
/* harmony import */ var _styles_keyframes_slide__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77991);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var AccordionRoot = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC,  true ? {
  target: "e1vr6zjl3"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);
var AccordionTrigger = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_2__/* .Trigger */ .xz,  true ? {
  target: "e1vr6zjl2"
} : 0)( true ? {
  name: "1uhr94a",
  styles: "display:flex;width:100%;align-items:center;justify-content:space-between;gap:8px"
} : 0);
var TriggerChevronIcon = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO,  true ? {
  target: "e1vr6zjl1"
} : 0)( true ? {
  name: "mtyh4w",
  styles: "[data-state='closed'] &{transform:rotate(180deg);}transition:transform 0.15s ease-in-out"
} : 0);
var AccordionContent = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_2__/* .Content */ .VY,  true ? {
  target: "e1vr6zjl0"
} : 0)("margin-top:12px;&[data-state='closed']{animation:", (0,_styles_keyframes_slide__WEBPACK_IMPORTED_MODULE_3__/* .slideUp */ .i)('var(--radix-collapsible-content-height)'), " 0.15s ease-in-out;}&[data-state='open']{display:flex;flex-direction:column;animation:", (0,_styles_keyframes_slide__WEBPACK_IMPORTED_MODULE_3__/* .slideDown */ .q)('var(--radix-collapsible-content-height)'), " 0.15s ease-in-out;gap:8px;}" + ( true ? "" : 0));

/***/ }),

/***/ 90038:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/pdf/tracking-clients",
      function () {
        return __webpack_require__(65355);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64266:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VY": function() { return /* binding */ $69cb30bb0017df05$export$7c6e2c02157bb7d2; },
/* harmony export */   "aV": function() { return /* binding */ $69cb30bb0017df05$export$54c2e3dc7acea9f5; },
/* harmony export */   "fC": function() { return /* binding */ $69cb30bb0017df05$export$be92b6f5f03c0fe9; },
/* harmony export */   "xz": function() { return /* binding */ $69cb30bb0017df05$export$41fb9f06171c75f4; }
/* harmony export */ });
/* unused harmony exports createTabsScope, Tabs, TabsList, TabsTrigger, TabsContent */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7896);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _radix_ui_primitive__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17998);
/* harmony import */ var _radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92211);
/* harmony import */ var _radix_ui_react_roving_focus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2923);
/* harmony import */ var _radix_ui_react_presence__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79616);
/* harmony import */ var _radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72714);
/* harmony import */ var _radix_ui_react_direction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59241);
/* harmony import */ var _radix_ui_react_use_controllable_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87695);
/* harmony import */ var _radix_ui_react_id__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23372);






















/* -------------------------------------------------------------------------------------------------
 * Tabs
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$TABS_NAME = 'Tabs';
const [$69cb30bb0017df05$var$createTabsContext, $69cb30bb0017df05$export$355f5bd209d7b13a] = (0,_radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContextScope */ .b)($69cb30bb0017df05$var$TABS_NAME, [
    _radix_ui_react_roving_focus__WEBPACK_IMPORTED_MODULE_2__/* .createRovingFocusGroupScope */ .Pc
]);
const $69cb30bb0017df05$var$useRovingFocusGroupScope = (0,_radix_ui_react_roving_focus__WEBPACK_IMPORTED_MODULE_2__/* .createRovingFocusGroupScope */ .Pc)();
const [$69cb30bb0017df05$var$TabsProvider, $69cb30bb0017df05$var$useTabsContext] = $69cb30bb0017df05$var$createTabsContext($69cb30bb0017df05$var$TABS_NAME);
const $69cb30bb0017df05$export$b2539bed5023c21c = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: valueProp , onValueChange: onValueChange , defaultValue: defaultValue , orientation: orientation = 'horizontal' , dir: dir , activationMode: activationMode = 'automatic' , ...tabsProps } = props;
    const direction = (0,_radix_ui_react_direction__WEBPACK_IMPORTED_MODULE_3__/* .useDirection */ .gm)(dir);
    const [value, setValue] = (0,_radix_ui_react_use_controllable_state__WEBPACK_IMPORTED_MODULE_4__/* .useControllableState */ .T)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($69cb30bb0017df05$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0,_radix_ui_react_id__WEBPACK_IMPORTED_MODULE_5__/* .useId */ .M)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_6__/* .Primitive.div */ .WV.div, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        dir: direction,
        "data-orientation": orientation
    }, tabsProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$b2539bed5023c21c, {
    displayName: $69cb30bb0017df05$var$TABS_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsList
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$TAB_LIST_NAME = 'TabsList';
const $69cb30bb0017df05$export$9712d22edc0d78c1 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , loop: loop = true , ...listProps } = props;
    const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_roving_focus__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: context.orientation,
        dir: context.dir,
        loop: loop
    }), /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_6__/* .Primitive.div */ .WV.div, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        role: "tablist",
        "aria-orientation": context.orientation
    }, listProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$9712d22edc0d78c1, {
    displayName: $69cb30bb0017df05$var$TAB_LIST_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsTrigger
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$TRIGGER_NAME = 'TabsTrigger';
const $69cb30bb0017df05$export$8114b9fdfdf9f3ba = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , disabled: disabled = false , ...triggerProps } = props;
    const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_roving_focus__WEBPACK_IMPORTED_MODULE_2__/* .Item */ .ck, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled,
        active: isSelected
    }), /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_6__/* .Primitive.button */ .WV.button, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        type: "button",
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": contentId,
        "data-state": isSelected ? 'active' : 'inactive',
        "data-disabled": disabled ? '' : undefined,
        disabled: disabled,
        id: triggerId
    }, triggerProps, {
        ref: forwardedRef,
        onMouseDown: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_8__/* .composeEventHandlers */ .M)(props.onMouseDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
            else // prevent focus to avoid accidental activation
            event.preventDefault();
        }),
        onKeyDown: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_8__/* .composeEventHandlers */ .M)(props.onKeyDown, (event)=>{
            if ([
                ' ',
                'Enter'
            ].includes(event.key)) context.onValueChange(value);
        }),
        onFocus: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_8__/* .composeEventHandlers */ .M)(props.onFocus, ()=>{
            // handle "automatic" activation if necessary
            // ie. activate tab following focus
            const isAutomaticActivation = context.activationMode !== 'manual';
            if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
        })
    })));
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$8114b9fdfdf9f3ba, {
    displayName: $69cb30bb0017df05$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsContent
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$CONTENT_NAME = 'TabsContent';
const $69cb30bb0017df05$export$bd905d70e8fd2ebb = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , forceMount: forceMount , children: children , ...contentProps } = props;
    const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(isSelected);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false
        );
        return ()=>cancelAnimationFrame(rAF)
        ;
    }, []);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_presence__WEBPACK_IMPORTED_MODULE_9__/* .Presence */ .z, {
        present: forceMount || isSelected
    }, ({ present: present  })=>/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_6__/* .Primitive.div */ .WV.div, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            "data-state": isSelected ? 'active' : 'inactive',
            "data-orientation": context.orientation,
            role: "tabpanel",
            "aria-labelledby": triggerId,
            hidden: !present,
            id: contentId,
            tabIndex: 0
        }, contentProps, {
            ref: forwardedRef,
            style: {
                ...props.style,
                animationDuration: isMountAnimationPreventedRef.current ? '0s' : undefined
            }
        }), present && children)
    );
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$bd905d70e8fd2ebb, {
    displayName: $69cb30bb0017df05$var$CONTENT_NAME
});
/* ---------------------------------------------------------------------------------------------- */ function $69cb30bb0017df05$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $69cb30bb0017df05$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
const $69cb30bb0017df05$export$be92b6f5f03c0fe9 = $69cb30bb0017df05$export$b2539bed5023c21c;
const $69cb30bb0017df05$export$54c2e3dc7acea9f5 = $69cb30bb0017df05$export$9712d22edc0d78c1;
const $69cb30bb0017df05$export$41fb9f06171c75f4 = $69cb30bb0017df05$export$8114b9fdfdf9f3ba;
const $69cb30bb0017df05$export$7c6e2c02157bb7d2 = $69cb30bb0017df05$export$bd905d70e8fd2ebb;





//# sourceMappingURL=index.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6577,7160,8984,7809,9569,5694,9941,7034,8898,823,5571,541,4242,5030,8784,1273,2534,4912,6416,3429,9774,2888,179], function() { return __webpack_exec__(90038); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);